export default __webpack_public_path__ + "static/media/music.601c07ae.mp3";